/* ============================================================
   SERAFINA — Il Dossier
   Turns the flat product description (paragraphs + pasted images)
   into an editorial that sells: numbered chapters, photo frames with
   ambient colour sampled from the photo, a texture loupe, a deal
   line (price · list price · −%), a sticky buy dock and a closing
   call to action. Tailored per product: photo-less chapters borrow
   the product's own gallery; thin descriptions are completed with
   factual chapters built from product data (colours, sizes, price)
   and the store's real shipping/returns promise.
   Runs entirely at runtime — no description is rewritten.
   ============================================================ */
(function () {
  'use strict';
  var d = document;
  if (!d.body || !d.body.classList.contains('template-product')) return;

  var T = {
    eyebrow: 'Il dossier',
    lens: 'Lente', lensHint: 'Passa il mouse sulla foto per vedere la trama',
    chapters: 'capitoli', chapter: 'capitolo', photos: 'fotografie', photo: 'fotografia', read: 'min di lettura',
    intro: 'La storia', details: 'Dettagli', sizes: 'Guida alle taglie', gallery: 'Galleria',
    brief: 'In breve', promiseTitle: 'La promessa SERAFINA',
    eyeIntro: 'Il capo', eyeWhy: 'Perché sceglierlo', eyeSpec: 'Scheda tecnica', eyeSizes: 'Guida alle taglie', eyeMore: 'Dettagli',
    accWhy: 'Nel dettaglio.', accSpec: 'I fatti, in breve.', accSizes: 'Trova la tua misura.', accMore: 'Da vicino.',
    price: 'Prezzo', category: 'Categoria', listPrice: 'Prezzo di listino', save: 'Risparmi',
    cta: 'Aggiungi al carrello', soldOut: 'Esaurito', choose: 'Scegli la taglia',
    endEyebrow: 'Pronta quando vuoi tu', endTitle: 'Ti piace? È a un tap da te.',
    freeShip: 'Spedizione gratuita', returns: 'Reso gratuito 30 giorni', delivery: 'Consegna in 5–8 giorni',
    promise: [
      'Spedizione gratuita in tutta Italia con Poste Italiane',
      'Consegna in 5–8 giorni lavorativi, con tracking',
      'Reso gratuito entro 30 giorni',
      'Pagamenti sicuri: Visa, Mastercard, American Express, PayPal, Apple Pay e Google Pay'
    ]
  };
  var UA_HOVER = window.matchMedia && matchMedia('(hover:hover) and (pointer:fine)').matches;
  var REDUCE = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var HAS_IO = 'IntersectionObserver' in window;
  var URGENT = /ordina subito|ordina ora|affrettat|scorte|saldi|termina|ultim[ie]|solo oggi|\boggi\b|esaurit|limitat|non perdere|occasione|offerta speciale/i;

  /* ---------- utils ---------- */
  function el(tag, cls, html) { var e = d.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function txt(n) { return (n.textContent || '').replace(/\s+/g, ' ').trim(); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function norm(s) { return String(s || '').toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim(); }
  function urlKey(u) { return String(u || '').replace(/^https?:/, '').split('?')[0]; }
  function stripBr(html) { return html.replace(/^(\s|<br\s*\/?>|&nbsp;)+/i, '').replace(/(\s|<br\s*\/?>|&nbsp;)+$/i, ''); }
  function isStrongOnly(node) {
    var kids = Array.prototype.filter.call(node.childNodes, function (c) { return !(c.nodeType === 3 && !c.textContent.trim()) && !(c.nodeType === 1 && c.tagName === 'BR'); });
    if (kids.length !== 1 || kids[0].nodeType !== 1) return false;
    var t = kids[0].tagName; return (t === 'STRONG' || t === 'B') && txt(kids[0]) === txt(node);
  }
  var BULLET = /^(?:\s|&nbsp;)*(?:[•·▪●\-–—\*]|&bull;)(?:\s|&nbsp;)*/i;
  var SPEC = /^(?:\s|&nbsp;)*(?:[•·▪●\-–—\*]|&bull;)?(?:\s|&nbsp;)*<(?:strong|b)>\s*([^<]{1,48}?)\s*:?\s*<\/(?:strong|b)>\s*:?\s*([\s\S]*)$/i;

  /* ---------- 1. parse the rte into chapters ---------- */
  function parse(rte, productTitle) {
    var chapters = [], cur = null, imgCount = 0, words = 0;
    function chapter(title, kind) { cur = { title: title, kind: kind || 'text', blocks: [], images: [] }; chapters.push(cur); return cur; }
    function ensure() { if (!cur) chapter(null, 'intro'); return cur; }
    function pushImages(node) {
      node.querySelectorAll('img').forEach(function (im) {
        var src = im.currentSrc || im.getAttribute('src') || im.getAttribute('data-src'); if (!src) return;
        ensure().images.push({ src: src, alt: im.getAttribute('alt') || '', w: +im.getAttribute('width') || 0, h: +im.getAttribute('height') || 0, origin: 'desc' });
        imgCount++;
      });
    }
    function textBlock(node) {
      var html = stripBr(node.innerHTML); if (!html || !txt(node)) return;
      words += txt(node).split(' ').length;
      if (isStrongOnly(node)) {
        var t = txt(node);
        if (URGENT.test(t)) return;                                     /* urgency copy is not part of the editorial voice */
        if (cur && cur.title && !cur.blocks.length && !cur.deck) { cur.deck = t; return; }   /* a bold line right under a heading is its deck */
        if (t.length > 56 || /offerta|spedizione|garanzia|reso/i.test(t)) { ensure().blocks.push({ type: 'note', html: esc(t) }); }
        else { chapter(t); }
        return;
      }
      var lines = html.split(/<br\s*\/?>/i).map(function (l) { return l.trim(); }).filter(function (l) { return l && l !== '&nbsp;'; });
      if (lines.length >= 2) {
        var specs = 0, bullets = 0;
        lines.forEach(function (l) { if (SPEC.test(l)) specs++; if (BULLET.test(l)) bullets++; });
        if (specs >= Math.max(2, Math.ceil(lines.length * .7))) { ensure().blocks.push({ type: 'spec', rows: lines.map(function (l) { var m = SPEC.exec(l); return m ? [m[1], m[2]] : [null, l]; }) }); return; }
        if (bullets >= Math.max(2, Math.ceil(lines.length * .7))) { ensure().blocks.push({ type: 'list', items: lines.map(function (l) { return l.replace(BULLET, ''); }) }); return; }
      }
      ensure().blocks.push({ type: 'p', html: html });
    }
    var BLOCKY = /^(P|DIV|H[1-6]|UL|OL|TABLE|IMG|FIGURE|SECTION|BLOCKQUOTE|HR)$/;
    function walk(node) {
      var tag = node.tagName;
      if ((tag === 'DIV' || tag === 'SECTION' || tag === 'SPAN' || tag === 'ARTICLE') && !node.classList.contains('rte-table-wrapper')) {
        var kids = Array.prototype.filter.call(node.children, function (k) { return BLOCKY.test(k.tagName); });
        if (kids.length && !node.querySelector('table')) { Array.prototype.forEach.call(node.children, function (k) { if (BLOCKY.test(k.tagName)) walk(k); else if (txt(k)) textBlock(k); }); return; }
      }
      visit(node);
    }
    function visit(node) {
      var tag = node.tagName;
      if (/^H[1-6]$/.test(tag)) { var ht = txt(node); if (ht) chapter(ht); return; }
      if (tag === 'TABLE' || node.querySelector('table')) { var tb = node.querySelector('table') || node; chapter(T.sizes, 'table').blocks.push({ type: 'table', node: tb }); return; }
      if (tag === 'UL' || tag === 'OL') { ensure().blocks.push({ type: 'list', items: Array.prototype.map.call(node.children, function (li) { return li.innerHTML; }) }); return; }
      if (tag === 'IMG') { var w = el('div'); w.appendChild(node.cloneNode(true)); pushImages(w); return; }
      if (tag === 'HR' || tag === 'SCRIPT' || tag === 'STYLE') return;
      if (node.querySelector && node.querySelector('img')) {
        if (!txt(node)) { pushImages(node); return; }
        pushImages(node); node.querySelectorAll('img').forEach(function (im) { im.remove(); }); textBlock(node); return;
      }
      textBlock(node);
    }
    Array.prototype.forEach.call(rte.children, walk);

    /* merge runs of one-line bullet paragraphs (div-per-line descriptions) into real lists / spec grids */
    chapters.forEach(function (c) {
      var outB = [], run = [], kind = null;
      function flush() {
        if (!run.length) return;
        if (run.length >= 2) {
          if (kind === 'spec') outB.push({ type: 'spec', rows: run.map(function (l) { var m = SPEC.exec(l); return m ? [m[1], m[2]] : [null, l]; }) });
          else outB.push({ type: 'list', items: run.map(function (l) { return l.replace(BULLET, ''); }) });
        } else run.forEach(function (l) { outB.push({ type: 'p', html: l }); });
        run = []; kind = null;
      }
      c.blocks.forEach(function (b) {
        if (b.type === 'p' && (BULLET.test(b.html) || SPEC.test(b.html)) && b.html.indexOf('<br') === -1) {
          var k = SPEC.test(b.html) ? 'spec' : 'list'; if (kind && kind !== k) flush(); kind = k; run.push(b.html);
        } else { flush(); outB.push(b); }
      });
      flush(); c.blocks = outB;
    });
    chapters = chapters.filter(function (c) { return !(URGENT.test(c.title || '') && !c.images.length); });
    chapters = chapters.filter(function (c) { return c.blocks.length || c.images.length || c.deck; });
    var pt = norm(productTitle);
    chapters.forEach(function (c, i) {
      if (c.title && pt && (norm(c.title) === pt || (pt.length > 12 && norm(c.title).indexOf(pt) === 0))) { c.title = c.deck || (i === 0 ? T.intro : T.details); c.deck = null; }
      if (!c.title) c.title = i === 0 ? T.intro : T.details;
      if (c.title === c.title.toUpperCase() && /\p{Lu}/u.test(c.title) && c.title.length > 3) {
        c.title = c.title.toLowerCase().replace(/(^|[.!?]\s+|\|\s*)(\p{L})/gu, function (m, a, b) { return a + b.toUpperCase(); });
      }
    });
    var hasSpec = chapters.some(function (c) { return c.blocks.some(function (b) { return b.type === 'spec'; }); });
    return { chapters: chapters, images: imgCount, words: words, hasSpec: hasSpec };
  }

  /* ---------- 2. commerce facts: price, list price, savings, the real buy button ---------- */
  var state = { root: null, model: null, productTitle: '', nIm: 0, imgSeq: 0, gallery: [], options: [], price: '', compare: '', pct: 0, saveTxt: '', buyBtn: null, thumb: '' };
  function moneyParts(s) {
    /* "1.211,03 kr" → prefix/suffix + separators, so savings can be printed in the shop's own format */
    var m = /^([^\d]*)([\d.,\s ']+)([^\d]*)$/.exec(String(s || '').trim()); if (!m) return null;
    var num = m[2].replace(/[\s ']/g, ''); var dec = '', th = '';
    var lastSep = Math.max(num.lastIndexOf(','), num.lastIndexOf('.'));
    if (lastSep > -1 && num.length - lastSep - 1 <= 2) { dec = num[lastSep]; th = dec === ',' ? '.' : ','; } else { th = num.indexOf('.') > -1 ? '.' : (num.indexOf(',') > -1 ? ',' : ''); }
    var digits = dec ? num.split(dec) : [num, ''];
    var whole = parseInt(digits[0].replace(/[^\d]/g, ''), 10) || 0, frac = digits[1] ? digits[1].replace(/[^\d]/g, '') : '';
    var cents = whole * 100 + (frac ? parseInt((frac + '0').slice(0, 2), 10) : 0);
    return { prefix: m[1], suffix: m[3], dec: dec, th: th, decimals: dec ? 2 : 0, cents: cents };
  }
  function fmtMoney(cents, like) {
    var whole = Math.floor(cents / 100), frac = cents % 100;
    var w = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, like.th || '');
    return like.prefix + w + (like.decimals ? like.dec + (frac < 10 ? '0' : '') + frac : '') + like.suffix;
  }
  function readCommerce() {
    var meta = d.querySelector('.product-single__meta');
    var p = meta && (meta.querySelector('[data-product-price]') || meta.querySelector('.product__price:not(.product__price--compare)'));
    var c = meta && meta.querySelector('[data-compare-price], .product__price--compare');
    var cw = c && c.closest('[data-product-price-wrap]'); var compareShown = c && !(cw && cw.classList.contains('hide')) && !c.classList.contains('hide');
    state.price = p ? txt(p) : ''; state.compare = compareShown ? txt(c) : '';
    var a = moneyParts(state.price), b = moneyParts(state.compare);
    if (a && b && b.cents > a.cents) { state.pct = Math.round((1 - a.cents / b.cents) * 100); state.saveTxt = fmtMoney(b.cents - a.cents, a); } else { state.pct = 0; state.compare = ''; state.saveTxt = ''; }
    state.buyBtn = meta && (meta.querySelector('.btn--add-to-cart') || meta.querySelector('.add-to-cart') || meta.querySelector('button[name="add"]'));
    var ti = d.querySelector('.product__thumb img, .product-image-main img, .product__main-photos img, .photoswipe__image, .product-single__photos img');
    state.thumb = ti ? (ti.currentSrc || ti.src || '') : '';
  }
  function buyNow(e) {
    if (e) e.preventDefault();
    var b = state.buyBtn; if (!b) return;
    if (b.disabled) { var vp = d.querySelector('.product-single__meta .variant-wrapper, .product-single__meta .product-block--variant') || b; vp.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    b.click();
  }
  function buyState() { var b = state.buyBtn; return { disabled: !b || b.disabled, label: b ? (b.disabled ? T.soldOut : T.cta) : T.cta }; }

  /* ---------- 3. render ---------- */
  function figure(c, im, chapterNo, tile) {
    state.imgSeq++;
    var fig = el('figure', 'sf-fig' + (im.origin === 'gallery' ? ' sf-fig--gallery' : ' sf-fig--desc') + (tile ? ' sf-fig--tile' : ' sf-fig--main'));
    fig.setAttribute('data-idx', state.imgSeq);
    var frame = el('div', 'sf-fig__frame');
    var img = el('img'); img.src = im.src; img.alt = im.alt || (c.title + ' — ' + (state.productTitle || '')); img.loading = 'lazy'; img.decoding = 'async';
    if (im.w && im.h) { img.width = im.w; img.height = im.h; }
    frame.appendChild(img);
    fig.appendChild(frame);
    im.fig = fig;
    img.addEventListener('error', function () { imageDied(c, im); }, { once: true });
    return fig;
  }
  /* a dead photo (404 on a foreign CDN, deleted file…) never shows a broken icon: it is removed,
     and if the chapter is left without a photo it borrows one from the product gallery when available */
  function imageDied(c, im) {
    if (im.dead) return; im.dead = true;
    var fig = im.fig, media = fig && fig.closest('.sf-ch__media'); if (fig && fig.parentNode) fig.parentNode.removeChild(fig); im.fig = null;
    if (!media) return;
    var sec = media.closest('.sf-ch');
    var live = Array.prototype.slice.call(media.querySelectorAll('.sf-fig'));
    if (!live.some(function (f) { return f.classList.contains('sf-fig--main'); }) && live.length) { live[0].classList.remove('sf-fig--tile'); live[0].classList.add('sf-fig--main'); }
    /* the same photo often exists in this store's own gallery under the same filename: prefer it */
    var base = function (u) { return (urlKey(u).split('/').pop() || '').toLowerCase(); };
    var want = base(im.src), src = null, gal = state.gallery || [], pool = state.pool || [];
    gal.some(function (u) { if (base(u) === want) { src = u; return true; } return false; });
    if (src) { var k = pool.indexOf(src); if (k > -1) pool.splice(k, 1); }
    else if (!live.length && pool.length) src = pool.shift();
    if (src) {
      var nim = { src: src, alt: '', origin: 'gallery' }; c.images.push(nim);
      var nf = figure(c, nim, sec ? sec.getAttribute('data-n') : '', false);
      /* the replacement takes the main slot; whatever was promoted goes back to being a tile */
      live.forEach(function (f) { f.classList.remove('sf-fig--main'); f.classList.add('sf-fig--tile'); });
      media.insertBefore(nf, media.firstChild);
      nf.dataset.sfBound = '1'; observeFigs([nf]); paintAmbient(nim);
    } else if (!live.length) {
      if (sec) { sec.classList.remove('sf-ch--media', 'sf-ch--plate'); sec.classList.add('sf-ch--solo'); } media.parentNode.removeChild(media); return;
    }
    tileCount(media); fitFrames(media);
  }
  function tileCount(media) { var n = media.querySelectorAll('.sf-fig').length; media.className = 'sf-ch__media sf-ch__media--c' + Math.min(n, 3); }
  function refreshCounts(root) { state.nIm = root.querySelectorAll('.sf-fig').length; }
  function metaLine(model, nIm) {
    var nCh = model.chapters.length, mins = Math.max(1, Math.round(model.words / 190));
    return nCh + ' ' + (nCh === 1 ? T.chapter : T.chapters) + (nIm ? ' · ' + nIm + ' ' + (nIm === 1 ? T.photo : T.photos) : '') + ' · ' + mins + ' ' + T.read;
  }
  function dealLine() {
    var wrap = el('div', 'sf-deal');
    var left = el('div', 'sf-deal__left');
    if (state.price) {
      left.appendChild(el('div', 'sf-deal__price', '<span class="sf-deal__now">' + esc(state.price) + '</span>' + (state.compare && state.pct ? '<s class="sf-deal__was">' + esc(state.compare) + '</s><span class="sf-pct sf-pct--big">−' + state.pct + '%</span>' : '')));
      if (state.saveTxt) left.appendChild(el('p', 'sf-deal__save', T.save + ' <b>' + esc(state.saveTxt) + '</b> · ' + T.freeShip.toLowerCase() + ' · ' + T.returns.toLowerCase()));
      else left.appendChild(el('p', 'sf-deal__save', T.freeShip + ' · ' + T.returns));
    }
    wrap.appendChild(left);
    var bs = buyState();
    var cta = el('button', 'sf-buy sf-buy--inline' + (bs.disabled ? ' is-disabled' : ''), '<span>' + bs.label + '</span>'); cta.type = 'button'; cta.addEventListener('click', buyNow);
    wrap.appendChild(cta);
    return wrap;
  }
  var ICONS = {
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>',
    back: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 5v5h5"/><path d="M4.6 14.5a8 8 0 1 0 1.7-8.3L3 10"/></svg>',
    pin: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-6-5.2-6-10a6 6 0 1 1 12 0c0 4.8-6 10-6 10z"/><circle cx="12" cy="11" r="2.2"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="10.5" width="14" height="9.5" rx="1.5"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5"/></svg>'
  };
  function trustRow() {
    var row = el('div', 'sf-trust');
    [[ICONS.truck, T.freeShip, 'con Poste Italiane, in tutta Italia'], [ICONS.pin, T.delivery, 'lavorativi, con tracking'], [ICONS.back, T.returns, 'senza domande'], [ICONS.lock, 'Pagamenti sicuri', 'circuito Shopify, crittografia SSL']].forEach(function (t) {
      row.appendChild(el('div', 'sf-trust__item', '<span class="sf-trust__ico" aria-hidden="true">' + t[0] + '</span><b>' + t[1] + '</b><small>' + t[2] + '</small>'));
    });
    return row;
  }
  function endBlock() {
    var bs = buyState();
    var wrap = el('section', 'sf-end');
    wrap.appendChild(el('h3', 'sf-end__title', esc(T.endTitle)));
    var row = el('div', 'sf-end__row');
    var cta = el('button', 'sf-buy sf-buy--big' + (bs.disabled ? ' is-disabled' : ''), '<span>' + bs.label + '</span>' + (state.price ? '<em>' + esc(state.price) + (state.compare && state.pct ? ' <s>' + esc(state.compare) + '</s>' : '') + '</em>' : '')); cta.type = 'button'; cta.addEventListener('click', buyNow);
    row.appendChild(cta);
    row.appendChild(el('ul', 'sf-end__promise', T.promise.slice(0, 3).map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('')));
    wrap.appendChild(row);
    var pay = d.querySelector('.product-single__meta .payment-icon'); if (pay && pay.parentNode) { var pc = el('div', 'sf-end__pay'); var clone = pay.parentNode.cloneNode(true); clone.removeAttribute('id'); pc.appendChild(clone); wrap.appendChild(pc); }
    return wrap;
  }
  function chapterSection(c, i) {
    var n = pad(i + 1);
    var sec = el('section', 'sf-ch' + (c.images.length ? ' sf-ch--media' : ' sf-ch--solo') + (c.kind === 'table' ? ' sf-ch--table' : '') + (c.images.length && !c.blocks.length && !c.deck ? ' sf-ch--plate' : ''));
    sec.id = 'sf-ch-' + (i + 1); sec.setAttribute('data-n', n);
    var text = el('div', 'sf-ch__text');
    var kind = c.kind === 'table' ? 'sizes' : (c.blocks.some(function (b) { return b.type === 'spec'; }) ? 'spec' : (i === 0 ? 'intro' : (c.blocks.some(function (b) { return b.type === 'list'; }) ? 'why' : 'more')));
    var eye = { intro: T.eyeIntro, why: T.eyeWhy, spec: T.eyeSpec, sizes: T.eyeSizes, more: T.eyeMore }[kind];
    var title = String(c.title).replace(/\s*[:：]\s*$/, '');
    var accent = c.deck || '';
    if (!accent) {
      if (kind === 'intro') { var sub = (state.productTitle || '').split('|')[1]; accent = sub ? sub.trim().toLowerCase().replace(/[.!]?$/, '.') : ''; }
      else accent = { why: T.accWhy, spec: T.accSpec, sizes: T.accSizes, more: T.accMore }[kind] || '';
      if (accent) accent = accent.charAt(0).toUpperCase() + accent.slice(1);
    }
    text.appendChild(el('p', 'sf-ch__eyebrow', n));
    text.appendChild(el('h3', 'sf-ch__title', esc(title) + (accent ? ' <em>' + esc(accent) + '</em>' : '')));
    var body = el('div', 'sf-ch__body');
    c.blocks.forEach(function (b) {
      if (b.type === 'p') body.appendChild(el('p', 'sf-p', b.html));
      else if (b.type === 'list') { var ul = el('ul', 'sf-list'); b.items.forEach(function (it) { ul.appendChild(el('li', '', it)); }); body.appendChild(ul); }
      else if (b.type === 'spec') { var dl = el('dl', 'sf-spec'); b.rows.forEach(function (r) { if (r[0]) { dl.appendChild(el('dt', '', r[0])); dl.appendChild(el('dd', '', r[1])); } else { dl.appendChild(el('dd', 'sf-spec__wide', r[1])); } }); body.appendChild(dl); }
      else if (b.type === 'note') body.appendChild(el('p', 'sf-note', b.html));
      else if (b.type === 'table') { var tw = el('div', 'sf-size'); tw.appendChild(b.node.cloneNode(true)); body.appendChild(tw); sizeTable(tw); }
    });
    text.appendChild(body);
    sec.appendChild(text);
    if (c.images.length) { var media = el('div', 'sf-ch__media'); c.images.forEach(function (im, k) { media.appendChild(figure(c, im, n, k > 0)); }); tileCount(media); sec.appendChild(media); }
    c.sec = sec;
    return sec;
  }
  function buildChips(model) {
    var chips = el('div', 'sf-dossier__chips');
    model.chapters.forEach(function (c, i) { var a = el('a', 'sf-chip', '<b>' + pad(i + 1) + '</b>' + esc(c.title)); a.href = '#sf-ch-' + (i + 1); chips.appendChild(a); });
    return chips;
  }
  function buildRail(model) {
    var rail = el('nav', 'sf-rail'); rail.setAttribute('aria-label', 'Capitoli');
    rail.appendChild(el('span', 'sf-rail__line', '<i></i>'));
    var list = el('ol', 'sf-rail__list'); rail.appendChild(list);
    model.chapters.forEach(function (c, i) { list.appendChild(el('li', '', '<a href="#sf-ch-' + (i + 1) + '"><b>' + pad(i + 1) + '</b><span>' + esc(c.title) + '</span></a>')); });
    return rail;
  }
  function render(model) {
    var root = el('section', 'sf-dossier'); root.setAttribute('aria-label', T.eyebrow);
    var list = el('div', 'sf-dossier__chapters');
    model.chapters.forEach(function (c, i) { list.appendChild(chapterSection(c, i)); });
    root.appendChild(list);
    return root;
  }

  /* ---------- 4. ambient colour from the photo ---------- */
  function ambient(src, cb) {
    try {
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var S = 28, cv = d.createElement('canvas'); cv.width = S; cv.height = S;
          var cx = cv.getContext('2d', { willReadFrequently: true }); cx.drawImage(im, 0, 0, S, S);
          var px = cx.getImageData(0, 0, S, S).data, r = 0, g = 0, b = 0, w = 0;
          for (var i = 0; i < px.length; i += 4) {
            var R = px[i], G = px[i + 1], B = px[i + 2], A = px[i + 3]; if (A < 120) continue;
            var mx = Math.max(R, G, B), mn = Math.min(R, G, B), l = (mx + mn) / 510, s = mx === mn ? 0 : (mx - mn) / (1 - Math.abs(2 * l - 1)) / 255;
            var wt = s * s * (1 - Math.abs(l - .5) * 1.6) + .02; if (wt < 0) wt = .02;
            r += R * wt; g += G * wt; b += B * wt; w += wt;
          }
          if (!w) { cb(null); return; }
          r /= w; g /= w; b /= w;
          var lum = (.299 * r + .587 * g + .114 * b) / 255;
          if (lum > .78) { var k = .78 / lum; r *= k; g *= k; b *= k; }
          cb({ r: Math.round(r), g: Math.round(g), b: Math.round(b) });
        } catch (e) { cb(null); }
      };
      im.onerror = function () { cb(null); };
      im.src = src;
    } catch (e) { cb(null); }
  }
  var ambCache = {};
  function paintAmbient(im) {
    var apply = function (col) {
      if (!col || !im.fig) return; im.amb = col;
      var v = col.r + ',' + col.g + ',' + col.b, sec = im.fig.closest('.sf-ch');
      im.fig.style.setProperty('--sf-amb', 'rgb(' + v + ')'); im.fig.style.setProperty('--sf-amb-rgb', v);
      if (sec && !sec.style.getPropertyValue('--sf-amb')) { sec.style.setProperty('--sf-amb', 'rgb(' + v + ')'); sec.style.setProperty('--sf-amb-rgb', v); }
      im.fig.classList.add('has-amb');
    };
    var k = urlKey(im.src);
    if (ambCache[k] && ambCache[k].done) { apply(ambCache[k].col); return; }
    if (ambCache[k]) { ambCache[k].q.push(apply); return; }
    ambCache[k] = { done: false, q: [apply], col: null };
    ambient(im.src, function (col) { ambCache[k].done = true; ambCache[k].col = col; ambCache[k].q.forEach(function (fn) { fn(col); }); ambCache[k].q = []; });
  }

  /* ---------- 5. size table: tap/hover highlights the column + row ---------- */
  function sizeTable(wrap) {
    var t = wrap.querySelector('table'); if (!t) return;
    function clear() { t.querySelectorAll('.is-hl').forEach(function (x) { x.classList.remove('is-hl'); }); }
    function mark(cell) {
      clear(); var tr = cell.parentNode; if (!tr) return; tr.classList.add('is-hl');
      var idx = Array.prototype.indexOf.call(tr.children, cell);
      t.querySelectorAll('tr').forEach(function (row) { var c = row.children[idx]; if (c) c.classList.add('is-hl'); });
    }
    t.addEventListener('pointerover', function (e) { var c = e.target.closest('td,th'); if (c && UA_HOVER) mark(c); });
    t.addEventListener('pointerleave', function () { if (UA_HOVER) clear(); });
    t.addEventListener('click', function (e) { var c = e.target.closest('td,th'); if (!c) return; if (c.classList.contains('is-hl') && !UA_HOVER) clear(); else mark(c); });
  }

  /* ---------- 6. frames: fit, reveal, parallax, loupe ---------- */
  function fitFrames(root) {
    var frames = Array.prototype.slice.call(root.querySelectorAll('.sf-fig--main .sf-fig__frame:not(.is-fit)'));
    function apply(fr) {
      if (fr.classList.contains('is-fit')) return true;
      var img = fr.querySelector('img'); if (!img || !img.complete || !img.naturalWidth || !img.naturalHeight) return false;
      var r = Math.max(.8, Math.min(1.5, img.naturalWidth / img.naturalHeight));
      fr.style.aspectRatio = r.toFixed(3); fr.style.setProperty('--fit', r.toFixed(3)); fr.classList.add('is-fit');
      var media = fr.closest('.sf-ch__media'); if (media) media.classList.toggle('sf-ch__media--wide', r > 1.15);
      return true;
    }
    frames.forEach(function (fr) { var img = fr.querySelector('img'); if (img && !apply(fr)) img.addEventListener('load', function () { apply(fr); }, { once: true }); });
    setTimeout(function () { frames.forEach(apply); }, 1200); setTimeout(function () { frames.forEach(apply); }, 4000);
  }
  var FR = { inView: new Set(), io: null, bound: false };
  function observeFigs(figs) {
    if (!figs.length) return;
    if (!HAS_IO) { figs.forEach(function (f) { f.classList.add('is-in'); }); }
    else {
      if (!FR.io) FR.io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { FR.inView.add(e.target); e.target.classList.add('is-in'); } else FR.inView.delete(e.target); }); }, { rootMargin: '12% 0px 12% 0px', threshold: 0 });
      figs.forEach(function (f) { FR.io.observe(f); });
    }
    if (!REDUCE && !FR.bound) {
      FR.bound = true; var busy = false;
      var upd = function () {
        var vh = innerHeight;
        FR.inView.forEach(function (f) {
          var r = f.getBoundingClientRect(), p = (r.top + r.height / 2 - vh / 2) / vh;
          var img = f.querySelector('img'); if (img) img.style.transform = 'translate3d(0,' + (p * -10).toFixed(2) + 'px,0) scale(1.05)';
        });
      };
      addEventListener('scroll', function () { if (busy) return; busy = true; requestAnimationFrame(function () { busy = false; upd(); }); }, { passive: true });
      setTimeout(upd, 50);
    }
  }

  /* ---------- 7. rail: active chapter + reading progress ---------- */
  var RAIL = { io: null, bound: false };
  function rail(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('.sf-rail__list li'));
    var secs = Array.prototype.slice.call(root.querySelectorAll('.sf-ch'));
    if (!secs.length) return;
    if (RAIL.io) RAIL.io.disconnect();
    if (HAS_IO) {
      RAIL.io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { var i = secs.indexOf(e.target); items.forEach(function (li, j) { li.classList.toggle('is-active', j === i); }); } });
      }, { rootMargin: '-35% 0px -55% 0px', threshold: 0 });
      secs.forEach(function (s) { RAIL.io.observe(s); });
    }
    function prog() { var r = root.getBoundingClientRect(), p = (innerHeight * .45 - r.top) / Math.max(1, r.height); p = Math.max(0, Math.min(1, p)); var f = root.querySelector('.sf-rail__line i'); if (f) f.style.height = (p * 100).toFixed(1) + '%'; }
    if (!RAIL.bound) { RAIL.bound = true; addEventListener('scroll', function () { requestAnimationFrame(prog); }, { passive: true }); }
    prog();
  }

  /* ---------- 8. the dock: a sticky buy bar that appears once the buy box has scrolled away ---------- */
  function dock() {
    if (!state.buyBtn) return;
    var bs = buyState();
    var bar = el('div', 'sf-dock');
    bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', T.cta);
    bar.innerHTML =
      '<div class="sf-dock__in">' +
        (state.thumb ? '<img class="sf-dock__thumb" alt="" src="' + esc(state.thumb) + '">' : '') +
        '<div class="sf-dock__meta"><span class="sf-dock__title">' + esc(state.productTitle) + '</span>' +
          '<span class="sf-dock__price"><b>' + esc(state.price) + '</b>' + (state.compare && state.pct ? '<s>' + esc(state.compare) + '</s><i>−' + state.pct + '%</i>' : '') + '</span>' +
          '<span class="sf-dock__ship">' + T.freeShip + ' · ' + T.returns + '</span></div>' +
        '<button type="button" class="sf-buy sf-buy--dock' + (bs.disabled ? ' is-disabled' : '') + '"><span>' + bs.label + '</span></button>' +
      '</div>';
    d.body.appendChild(bar);
    bar.querySelector('.sf-buy').addEventListener('click', buyNow);
    /* visible only when the real buy button is above the viewport (i.e. the shopper has scrolled past it) */
    var btn = state.buyBtn, shown = false;
    function upd() {
      var r = btn.getBoundingClientRect();
      var want = r.bottom < 0 && !d.documentElement.classList.contains('js-drawer-open') && !d.body.classList.contains('js-drawer-open');
      if (want !== shown) { shown = want; bar.classList.toggle('is-on', want); d.documentElement.classList.toggle('sf-dock-on', want); }
    }
    var busy = false;
    addEventListener('scroll', function () { if (busy) return; busy = true; requestAnimationFrame(function () { busy = false; upd(); }); }, { passive: true });
    addEventListener('resize', upd); setTimeout(upd, 300);
    /* mirror sold-out / label changes of the theme button */
    if (window.MutationObserver) new MutationObserver(function () {
      var s = buyState(); bar.querySelectorAll('.sf-buy, .sf-buy--inline, .sf-buy--big').forEach(function () {});
      d.querySelectorAll('.sf-buy').forEach(function (b) { b.classList.toggle('is-disabled', s.disabled); var sp = b.querySelector('span'); if (sp) sp.textContent = s.label; });
    }).observe(btn, { attributes: true, childList: true, subtree: true, attributeFilter: ['disabled', 'class'] });
  }

  /* ---------- 9. tailoring from product data ---------- */
  function productJsonUrl() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) { var c = d.querySelector('link[rel="canonical"]'); if (c) m = (c.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/); }
    return m ? (m[1].indexOf('http') === 0 ? m[1] : '/products/' + m[1] + '.js') : null;
  }
  function augment(pj) {
    var model = state.model, root = state.root, changed = false;
    state.gallery = (pj.images || []).map(function (u) { return /^\/\//.test(u) ? 'https:' + u : u; });
    state.options = (pj.options || []).filter(function (o) { return o && o.values && o.values.length && !/^title$/i.test(o.name) && !(o.values.length === 1 && /default/i.test(o.values[0])); }).map(function (o) { return { name: o.name, values: o.values }; });
    if (!state.thumb && state.gallery[0]) { state.thumb = state.gallery[0]; var dt = d.querySelector('.sf-dock__in'); if (dt && !dt.querySelector('img')) { var im0 = el('img', 'sf-dock__thumb'); im0.alt = ''; im0.src = state.thumb; dt.insertBefore(im0, dt.firstChild); } }
    var used = {}; model.chapters.forEach(function (c) { c.images.forEach(function (im) { used[urlKey(im.src)] = 1; }); });
    var pool = state.gallery.filter(function (u) { return !used[urlKey(u)]; });
    if (pool.length > 1) pool = pool.slice(1).concat(pool.slice(0, 1));   /* the hero is the gallery's first photo; use it last */
    state.pool = pool;
    model.chapters.forEach(function (c) { c.images.forEach(function (im) { if (im.dead && !im.healed && c.sec) { im.healed = true; var md = c.sec.querySelector('.sf-ch__media'); if (md && !md.querySelector('.sf-fig--main')) { im.dead = false; im.fig = null; var tmp = el('figure'); md.appendChild(tmp); im.fig = tmp; imageDied(c, im); } } }); });

    /* photo-less chapters borrow the gallery */
    model.chapters.forEach(function (c) {
      if (c.images.some(function (im) { return !im.dead; }) || !pool.length) return;
      var im = { src: pool.shift(), alt: '', origin: 'gallery' }; c.images.push(im);
      var sec = c.sec, media = sec.querySelector('.sf-ch__media') || el('div', 'sf-ch__media');
      media.appendChild(figure(c, im, sec.getAttribute('data-n'), false)); tileCount(media);
      if (!media.parentNode) sec.appendChild(media); sec.classList.remove('sf-ch--solo'); sec.classList.add('sf-ch--media'); if (!c.blocks.length && !c.deck) sec.classList.add('sf-ch--plate');
      changed = true;
    });
    /* collages (phones): the remaining gallery photos become small tiles beside each chapter's photo, round-robin, max 2 per chapter */
    var mediaCh = model.chapters.filter(function (c) { return c.images.some(function (im) { return !im.dead; }) && c.sec && c.sec.querySelector('.sf-ch__media'); });
    var pass = 0;
    while (pool.length && pass < 2 && mediaCh.length) {
      mediaCh.forEach(function (c) {
        if (!pool.length) return;
        var media = c.sec.querySelector('.sf-ch__media'); if (media.querySelectorAll('.sf-fig').length >= 3) return;
        var im = { src: pool.shift(), alt: '', origin: 'gallery', tile: true }; c.extras = c.extras || []; c.extras.push(im);
        media.appendChild(figure(c, im, c.sec.getAttribute('data-n'), true)); tileCount(media); changed = true;
      });
      pass++;
    }
    if (changed) { /* sections were re-mounted in order; nothing else to rebuild in the simple layout */ }
    var figsNew = Array.prototype.filter.call(root.querySelectorAll('.sf-fig'), function (f) { return !f.dataset.sfBound; });
    figsNew.forEach(function (f) { f.dataset.sfBound = '1'; });
    observeFigs(figsNew); fitFrames(root); refreshCounts(root);
    model.chapters.forEach(function (c) { c.images.forEach(function (im) { if (im.fig && !im.amb) paintAmbient(im); }); });
  }

  /* ---------- boot ---------- */
  function init() {
    var rte = d.querySelector('.product-single__meta .product-block > .rte:not(.product__policies)') || d.querySelector('.product-single__description .rte, .product-single__description');
    if (!rte || rte.dataset.sfDossier) return;
    var section = rte.closest('.shopify-section'); if (!section) return;
    var titleEl = d.querySelector('.product-single__title'); var productTitle = titleEl ? txt(titleEl) : '';
    if (productTitle && productTitle === productTitle.toUpperCase() && /[A-Z]/.test(productTitle)) {
      productTitle = productTitle.toLowerCase().replace(/(^|\|\s*|[.!?]\s+)(\p{L})/gu, function (m, a, b) { return a + b.toUpperCase(); });
    }
    state.productTitle = productTitle; readCommerce();
    var model = parse(rte, productTitle);
    if (!model.chapters.length) model.chapters.push({ title: T.intro, kind: 'intro', blocks: [], images: [] });
    rte.dataset.sfDossier = '1';
    state.model = model;
    var root = render(model); state.root = root;
    var block = rte.closest('.product-block') || rte; block.parentNode.removeChild(block);
    section.appendChild(root);
    var figs = Array.prototype.slice.call(root.querySelectorAll('.sf-fig')); figs.forEach(function (f) { f.dataset.sfBound = '1'; });
    observeFigs(figs); fitFrames(root); refreshCounts(root);
    model.chapters.forEach(function (c) { c.images.forEach(paintAmbient); });
    var u = productJsonUrl();
    if (u && window.fetch) fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (pj) { if (pj) augment(pj); }).catch(function () {});
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
